import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';
import { QfaEventType } from '../enums/event-type.enum';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private readonly appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.instrumentationKey,
        connectionString: environment.appInsightsConnString,
      },
    });
    this.appInsights.loadAppInsights();

    // Check if appInsights is loaded and log the status
    if (this.appInsights) {
      console.log('Application Insights has been initialized successfully.');
    } else {
      console.error('Application Insights failed to initialize.');
    }
  }

  logEvent(eventType: QfaEventType, message: string): void {
    this.appInsights.trackEvent({ name: eventType, properties: { message } });
  }

  logError(error: Error): void {
    this.appInsights.trackException({ exception: error });
  }
}
